import { Fragment, useState } from 'react';

import IconButton from '../IconButton';
import CloseIcon from '../../assets/imgs/icon/close.svg';
import Flex from '../Flex';

interface SuccessProps {
	message: string;
}

export const SuccessMessage = ({ message }: SuccessProps): JSX.Element => {
	const [show, setShow] = useState(true);
	return (
		<Fragment>
			{show && (
				<Flex
					$flexDirection="row"
					$alignItems="center"
					$padding="12px"
					$margin="0 0 12px 0"
					$height="auto"
					$placeContent="center space-between"
					className="alert alert-success"
				>
					<strong>{message}</strong>
					<IconButton
						onClick={() => setShow(false)}
						width={12}
						height={12}
						url={CloseIcon}
						alt={'close'}
					></IconButton>
				</Flex>
			)}
		</Fragment>
	);
};
